@if (isLoading;) {
  <div>
    <ng-container>
      <p-progressSpinner></p-progressSpinner>
    </ng-container>
  </div>
}

@if (!isLoading && filteredNotifications !== null) {
  <div aria-label="E-Notification-List">
    <p-table #dt class="frozen-columns-table" currentPageReportTemplate="Showing {first} - {last} of {totalRecords} items"
      paginatorDropdownAppendTo="body" responsiveLayout="scroll" [alwaysShowPaginator]="false" [paginator]="true"
      [rows]="10" [rowsPerPageOptions]="[10, 25, 50]" [scrollable]="true" [showCurrentPageReport]="true"
      [value]="filteredNotifications">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 15rem">Service Line</th>
          <th style="width: 15rem">Notification Type</th>
          <th style="width: 15rem">Source</th>
          <th pSortableColumn="createdOn" style="width: 20rem">
            Notification Received Date/Time
            <p-sortIcon field="createdOn"></p-sortIcon>
          </th>
          <th style="width: 15rem;">Sent By</th>
          <th style="width: 15rem;">Status</th>
        </tr>
        <tr>
          <th alignFrozen="left" pFrozenColumn [frozen]="true">
            <p-multiSelect appendTo="body" placeholder="Filter" scrollHeight="200px" styleClass="p-column-filter"
              [options]="lineNumbers" [(ngModel)]="appliedFilters.lineNumber.value"
              (onChange)="filterTable($event.value, 'lineNumber', 'in')">
              <ng-template let-option pTemplate="item">
                <div class="p-multiselect-representative-option">
                  <span class="ml-1">{{ option.value }}</span>
                </div>
              </ng-template>
            </p-multiSelect>
          </th>
          <th style="width: 15rem"></th>
          <th style="width: 15rem"></th>
          <th style="width: 20rem">
            <p-date-picker appendTo="body" dateFormat="mm/dd/y" placeholder="mm/dd/yyyy hh:mm:ss" selectionMode="range"
              styleClass="p-column-filter" [showButtonBar]="true" [showIcon]="true"
              [(ngModel)]="appliedFilters.createdOn.value"
            (ngModelChange)="filterTable(appliedFilters.createdOn.value, 'createdOn', 'customDate')"></p-date-picker>
          </th>
          <th style="width: 15rem;"></th>
          <th style="width: 15rem;">
            <p-select appendTo="body" placeholder="Filter" scrollHeight="200px" styleClass="p-column-filter"
              [options]="notificationEvent"
              [showClear]="true" [(ngModel)]="appliedFilters.notificationEvent.value"
              (onChange)="filterTable($event.value, 'notificationEvent', 'contains')">
              <ng-template let-option pTemplate="item">
                <div class="p-multiselect-representative-option">
                  <span class="ml-1">{{option.label}}</span>
                </div>
              </ng-template>
            </p-select>
          </th>
        </tr>
      </ng-template>
      <ng-template let-rowData let-rowIndex="rowIndex" pTemplate="body">
        <tr>
          <td style="width: 15rem">{{ rowData['lineNumber'] }}</td>
          <td style="width: 15rem">{{ rowData['notificationType'] }}</td>
          <td style="width: 15rem">{{ rowData['documentSource'] }}</td>
          <td style="width: 20rem">{{ rowData['createdOn'] | utcToLocal: 'MM/dd/yyyy hh:mm:ss a' }}</td>
          <td style="width: 15rem">{{ rowData['createdBy'] }}</td>
          <td style="width: 15rem">{{ getNotificationEvent(rowData['notificationEvent']) }} </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6">No records found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
}
